import axios from "axios"
import { createApp } from "vue"

axios.defaults.baseURL = import.meta.env.VITE_BASE_API_URL

import App from "src/App.vue"
import router from "src/router"

// Components Files
import VPageHeader from "src/components/VPageHeader.vue"
import VTable from "src/components/VTable.vue"
import VSelect from "src/components/VSelect.vue"
import VPagination from "src/components/VPagination.vue"
import ExportButton from "src/components/ExportButton.vue"
import VTabs from "src/components/VTabs.vue"
import VInput from "src/components/VInput.vue"
import VNoteHelper from "src/components/VNoteHelper.vue"
import VButton from "src/components/VButton.vue"
import VValidator from "src/components/VValidator.vue"
import VLoading from "src/components/VLoading.vue"
import VCard from "src/components/VCard.vue"
import VDeleteModel from "src/components/VDeleteModel.vue"
import VSection from "src/components/VSection.vue"
import VAuthLanguage from "src/components/AuthLanguage.vue"
import VToast from "src/components/VToast.vue"
import VMenu from "src/components/VMenu.vue"
import VImage from "src/components/VImage.vue"
import VBreadcrumb from "src/components/VBreadcrumb.vue"
import VMerchantFilterBanner from "src/components/VMerchantFilterBanner.vue"

// Global CSS
import "src/assets/index.css"

const app = createApp(App)

// Global Components
app.component("VPageHeader", VPageHeader)
app.component("VTable", VTable)
app.component("VSelect", VSelect)
app.component("VPagination", VPagination)
app.component("ExportButton", ExportButton)
app.component("VTabs", VTabs)
app.component("VInput", VInput)
app.component("VNoteHelper", VNoteHelper)
app.component("VButton", VButton)
app.component("VValidator", VValidator)
app.component("VLoading", VLoading)
app.component("VCard", VCard)
app.component("VDeleteModel", VDeleteModel)
app.component("VSection", VSection)
app.component("VAuthLanguage", VAuthLanguage)
app.component("VToast", VToast)
app.component("VMenu", VMenu)
app.component("VImage", VImage)
app.component("VBreadcrumb", VBreadcrumb)
app.component("VMerchantFilterBanner", VMerchantFilterBanner)

app.use(router)

app.mount("#app")
